module.exports = function () {
    var tabsModuleClass = 'tabs-module';
    var tabsModuleSelector = '.' + tabsModuleClass;

    if ($(tabsModuleSelector).length === 0) {
        return;
    }

    var tabsModuleTabClass = tabsModuleClass + '__tab';
    var tabsModuleTabSelector = '.' + tabsModuleTabClass;
    var tabsModuleContainerClass = tabsModuleClass + '__container';
    var tabsModuleContainerSelector = '.' + tabsModuleContainerClass;
    var tabsModuleSwiperClass = tabsModuleClass + '__swiper';
    var tabsModuleSwiperSelector = '.' + tabsModuleSwiperClass;
    var tabsModuleActiveTabClass = tabsModuleTabClass + '--active';
    var tabsModuleActiveTabSelector = '.' + tabsModuleActiveTabClass;
    var tabsModuleTabContainerClass = tabsModuleClass + '__tab-container';
    var tabsModuleTabContainerSelector = '.' + tabsModuleTabContainerClass;
    var tabsModuleTabTitleClass = tabsModuleClass + '__tab-title';
    var tabsModuleTabTitleSelector = '.' + tabsModuleTabTitleClass;
    var tabsModuleTabBarClass = tabsModuleClass + '__tab-bar';
    var tabsModuleTabBarSelector = '.' + tabsModuleTabBarClass;
    var tabsModuleTabFadeClass = tabsModuleClass + '__tab-fade';
    var tabsModuleTabFadeHiddenClass = tabsModuleTabFadeClass + '--hidden';
    var tabsModuleTabFadeLeftClass = tabsModuleTabFadeClass + '--left';
    var tabsModuleTabFadeLeftSelector = '.' + tabsModuleTabFadeLeftClass;
    var tabsModuleTabFadeRightClass = tabsModuleTabFadeClass + '--right';
    var tabsModuleTabFadeRightSelector = '.' + tabsModuleTabFadeRightClass;

    var tabsModuleTabPaneClass = tabsModuleClass + '__tab-pane';
    var tabsModuleTabPaneSelector = '.' + tabsModuleTabPaneClass;
    var tabsModuleActiveTabPaneClass = tabsModuleTabPaneClass + '--active';
    var tabsModuleActiveTabPaneSelector = '.' + tabsModuleActiveTabPaneClass;
    var tabsModuleHiddenTabPaneClass = tabsModuleTabPaneClass + '--hidden';
    var tabsModuleTabPaneContainerClass = tabsModuleClass + '__tabs-module__tab-pane-container';
    var tabsModuleTabPaneContainerSelector = '.' + tabsModuleTabPaneContainerClass;

    var setTabFadeState = function ($tabsModuleTabContainer) {
        var $swiper = $tabsModuleTabContainer.closest(tabsModuleSwiperSelector);
        var $tabsModuleContainer = $tabsModuleTabContainer.closest(tabsModuleContainerSelector);
        
        var $lastTab = $tabsModuleTabContainer.find(tabsModuleTabSelector).last();
        if ($tabsModuleContainer.length && $swiper.length && $lastTab.length) {
            if (Math.floor($lastTab[0].getBoundingClientRect().right) > Math.floor($swiper[0].getBoundingClientRect().right)) {
                $tabsModuleContainer.find(tabsModuleTabFadeRightSelector).removeClass(tabsModuleTabFadeHiddenClass);
            }
            else {
                $tabsModuleContainer.find(tabsModuleTabFadeRightSelector).addClass(tabsModuleTabFadeHiddenClass);
            }
        }
    }

    var handleSwiperResizeEvent = function (swiper) {
        setTabFadeState($(swiper.wrapperEl));
    }

    var handleSwiperSlideChangeTransitionStartEvent = function (swiper) {
        setTimeout(function () {
            setTabFadeState($(swiper.wrapperEl));
        }, 50);
    }

    var handleSwiperTransitionEndEvent = function (swiper) {
        setTabFadeState($(swiper.wrapperEl));
    }

    $(tabsModuleSelector).each(function () {
        var $tabsModule = $(this);
        var $tabsModuleSwiper = $tabsModule.find('.swiper');
        var numberOfItems = $tabsModuleSwiper.find('.swiper-slide').length;
        
        var smMobileSliesPerView, lgMobileSliesPerView, tabletSlidesPerView, smDesktopSlidesPerView, lgDesktopSlidesPerView;

        if ($tabsModule.data('tabSpvSmMobile')) {
            smMobileSliesPerView = $tabsModule.data('tabSpvSmMobile');
        }
        else {
            smMobileSliesPerView = 1.25;
        }

        if ($tabsModule.data('tabSpvLgMobile')) {
            lgMobileSliesPerView = $tabsModule.data('tabSpvLgMobile');
        }
        else {
            lgMobileSliesPerView = 2.25;
        }

        if ($tabsModule.data('tabSpvTablet')) {
            tabletSlidesPerView = $tabsModule.data('tabSpvTablet');
        }
        else {
            if (numberOfItems >= 3) {
                tabletSlidesPerView = 3.25;
            }
            else {
                tabletSlidesPerView = 2.25;
            }
        }

        if ($tabsModule.data('tabSpvSmDesktop')) {
            smDesktopSlidesPerView = $tabsModule.data('tabSpvSmDesktop');
        }
        else {
            if (numberOfItems >= 4) {
                smDesktopSlidesPerView = 4.25;
            }
            else if (numberOfItems == 3) {
                smDesktopSlidesPerView = 3.25;
            }
            else {
                smDesktopSlidesPerView = 'auto';
            }
        }

        if ($tabsModule.data('tabSpvLgDesktop')) {
            lgDesktopSlidesPerView = $tabsModule.data('tabSpvLgDesktop');
        }
        else {
            if (numberOfItems >= 4) {
                lgDesktopSlidesPerView = 4.25;
            }
            else if (numberOfItems == 3) {
                lgDesktopSlidesPerView = 3.25;
            }
            else {
                lgDesktopSlidesPerView = 'auto';
            }
        }
        
        var tabsModuleSwiperInstance = new Swiper($tabsModuleSwiper[0], {
            a11y: true,
            direction: 'horizontal',
            slidesPerView: smMobileSliesPerView,
            spaceBetween: 8,
            freeMode: true,
            grabCursor: true,
            breakpoints: {
                431: {
                    slidesPerView: lgMobileSliesPerView
                },
                [ICF.Variables.Breakpoints.Tablet]: {
                    slidesPerView: tabletSlidesPerView
                },
                [ICF.Variables.Breakpoints.DesktopSm]: {
                    slidesPerView: smDesktopSlidesPerView
                },
                [ICF.Variables.Breakpoints.Desktop]: {
                    slidesPerView: lgDesktopSlidesPerView
                }
            },
            on: {
                resize(swiper) {
                    handleSwiperResizeEvent(swiper);
                },
                slideChangeTransitionStart(swiper) {
                    handleSwiperSlideChangeTransitionStartEvent(swiper);
                },
                transitionEnd(swiper) {
                    handleSwiperTransitionEndEvent(swiper);
                }
            }
        });
    });
    
    $('.tabs-module__edit-tab-button').on('click', function () {
        $(this).closest('.tabs-module__tab-wrapper').find(tabsModuleTabSelector).click();
    });

    $(tabsModuleTabSelector).on('click', function () {
        $clickedTab = $(this);
        $activeTab = $clickedTab.closest(tabsModuleTabContainerSelector).find(tabsModuleActiveTabSelector);
        if (!$clickedTab.is($activeTab)) {
            var $tabContainer = $clickedTab.closest(tabsModuleTabContainerSelector);
            var inactiveTabBackgroundColorClass = $tabContainer.data('inactiveTabBackgroundColorClass');
            var inactiveTabForegroundColorClass = $tabContainer.data('inactiveTabForegroundColorClass');
            var inactiveTabAccentColorClass = $tabContainer.data('inactiveTabAccentColorClass');
            var activeTabBackgroundColorClass = $tabContainer.data('activeTabBackgroundColorClass');
            var activeTabForegroundColorClass = $tabContainer.data('activeTabForegroundColorClass');
            var activeTabAccentColorClass = $tabContainer.data('activeTabAccentColorClass');

            $activeTab.removeClass(tabsModuleActiveTabClass);
            $activeTab.find(tabsModuleTabTitleSelector).removeClass(activeTabBackgroundColorClass).removeClass(activeTabForegroundColorClass).addClass(inactiveTabBackgroundColorClass).addClass(inactiveTabForegroundColorClass);
            $activeTab.find(tabsModuleTabBarSelector).removeClass(activeTabAccentColorClass).addClass(inactiveTabAccentColorClass);
            $activeTab.attr('aria-selected', false);

            $clickedTab.addClass(tabsModuleActiveTabClass)
            $clickedTab.find(tabsModuleTabTitleSelector).removeClass(inactiveTabBackgroundColorClass).removeClass(inactiveTabForegroundColorClass).addClass(activeTabBackgroundColorClass).addClass(activeTabForegroundColorClass);
            $clickedTab.find(tabsModuleTabBarSelector).removeClass(inactiveTabAccentColorClass).addClass(activeTabAccentColorClass);
            $clickedTab.attr('aria-selected', true);

            var swiper = $clickedTab.closest(tabsModuleSwiperSelector)[0];
            if (swiper.swiper != undefined) {
                swiper.swiper.slideTo($clickedTab.closest(tabsModuleTabContainerSelector).find(tabsModuleTabSelector).index($clickedTab));
            }

            var $tabsModule = $clickedTab.closest(tabsModuleSelector);
            var $activeTabPane = $tabsModule.find(tabsModuleActiveTabPaneSelector);

            $activeTabPane.removeClass(tabsModuleActiveTabPaneClass).attr('aria-hidden', 'true').attr('tabindex', '-1');
            setTimeout(function () {
                $activeTabPane.addClass(tabsModuleHiddenTabPaneClass);
            }, 300);

            var $clickedTabPane = $tabsModule.find('#' + $clickedTab.attr('aria-controls'));
            $clickedTabPane.removeClass(tabsModuleHiddenTabPaneClass).attr('aria-hidden', 'false').attr('tabindex', '');
            setTimeout(function () {
                $clickedTabPane.addClass(tabsModuleActiveTabPaneClass);
            }, 0);
        }

        return false;
    });
   
    $(tabsModuleTabContainerSelector).each(function () {
        setTabFadeState($(this));
    });
};
